<template>
	<div>
		<a
			href="https://exavid03.blob.core.windows.net/resultados/ResultadosAlgebra3Octubre.pdf"
			target="_blank"
		>
			<sui-segment color="blue" aligned="center"
				>Resultados Álgebra
			</sui-segment>
		</a>
		<br />
		<a
			href="https://exavid03.blob.core.windows.net/resultados/ResultadosCiencias3Octubre.pdf"
			target="_blank"
		>
			<sui-segment color="blue" aligned="center"
				>Resultados Ciencias
			</sui-segment>
		</a>
	</div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import screenfull from 'screenfull';
import moment from 'moment';
import Notification from '../../../utils/notification';
export default {
	data() {
		return {
			nombreExamen: '',
			introduccionExamen: '',
			fechaYHoraInicio: '',
			sinExamenAsignado: false,
			aceptoTerminosYCondiciones: false,
			fechaInicioLetras: '',
			examenFinalizado: false,
			examenIniciado: false
		};
	},
	computed: {
		...mapGetters('oidc', ['oidcUser']),
		...mapGetters('sidebar', ['getExamen']),
		...mapGetters('aspirantes', ['getLoading']),
		...mapGetters('configuraciones', [
			'getEnableFullScreen',
			'getMensajeTerminado',
			'getObservacionTerminado',
			'getEnableCameraRecorder',
			'getEnableScreenRecorder'
		]),
		...mapGetters('examenAspirante', ['getPermisoCamara', 'getPermisoScreen'])
	},
	mounted: function() {
		this.establecerAreaDeConocimiento('Resultados');
	},
	methods: {
		...mapActions('app', ['establecerAreaDeConocimiento'])
	}
};
</script>
<style lang="scss">
a:visited,
a:hover {
	color: black !important;
}
</style>
